// src/libraries/ToolManager.js

class ToolManager {
    constructor() {
      this.currentTool = "select"; // default tool
    }
  
    setTool(toolName) {
      this.currentTool = toolName;
      if (window.canvasEngine) {
        window.canvasEngine.currentTool = toolName;
        window.canvasEngine.isPanning = false;
        window.canvasEngine.isDrawing = false;
        window.canvasEngine.drawStart = null;
        // window.canvasEngine.selectedRects = []; // ✅ Optional: clear selection on tool change
        window.canvasEngine.rulerHandler.onToolchange()
        // 🧼 Clean up rectangle tool residuals
        const engine = window.canvasEngine;
        if (engine.previewRect) engine.previewRect = null;
        if (engine.previewInstance) engine.previewInstance = null;
        engine.draw(); // Refresh canvas

        setTimeout(() => {
      if (typeof window.canvasEngine.handleToolChange === 'function') {
        window.canvasEngine.handleToolChange(toolName);
      }
    }, 0);

      }
      console.log(`🛠️ Tool switched to: ${toolName}`);
    }
  
    getCurrentTool() {
      return this.currentTool;
    }
  }
  
  window.ToolManager = new ToolManager(); // ✅ Attach globally
  export default window.ToolManager;
  